import * as React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {TextField, TextFieldProps} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {merge} from "lodash";
import {StyledInputLabel} from "../providers/layout/LayoutProvider";
import {OutlinedInputProps} from "@mui/material/OutlinedInput";

export type FormInputTextProps = Omit<TextFieldProps, 'name'> & {
   name: string;
   label: string;
   errorMessage?: string
   handleError?: boolean
}

export const FormInputText = ({name, label, errorMessage, handleError, ...rest}: FormInputTextProps) => {
   const {style, InputProps} = rest;
   const classes = useStyles();

   const methods = useFormContext();
   const {control, formState: {errors}} = methods;
   const currentError = errors[name];
   const showError = !!currentError;

   const newStyle = merge(style, {
      border: showError ? '1px solid #f00000' : '1px solid #d0d0d0',
      marginBottom: '8px',
      borderRadius: '2px'
   });

   const newProps: OutlinedInputProps = merge(InputProps, {
      disableUnderline: true,
      style: {
         backgroundColor: 'transparent',
      },
      sx: {
         input: {
            padding: '21px 12px 4px !important',
            background: 'none !important',
            border: '0px !important',
            marginBottom: '0px !important',
            textIndent: '0px !important',
            height: 'auto !important'
         },
         focused: 'none',
         minHeight: '48px'
      }
   });

   return (
      <div className={classes.noBorderRadius}>
         <Controller
            name={name}
            control={control}
            render={({
                        field: {onChange, value},
                        fieldState: {error}
                     }) => (
               <TextField
                  id={name}
                  size="small"
                  fullWidth
                  label={<StyledInputLabel type={"main"} variant={"body1"}>{label}</StyledInputLabel>}
                  variant="filled"
                  value={value || undefined}
                  error={showError}
                  onChange={onChange}
                  margin={"none"}
                  InputLabelProps={{
                     shrink: true
                  }}
                  helperText={(handleError && showError) ? currentError.message || errorMessage : undefined}
                  InputProps={newProps}
                  style={newStyle}
                  {...rest}
               />
            )}/>
      </div>
   );
};

const useStyles = makeStyles({
   noBorderRadius: {
      "& fieldset": {
         borderRadius: 0,
      },
      width: '100%',
      display: 'flex'
   }
});
